// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

export const getData = createAsyncThunk('appLogDatos/getData', async param => {
  const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/Log`, {params: param})
  return {
    param,
    data: response.data.data !== null ? response.data.data : [],
    totalPages: response.data.total
  }
})

export const getTipoEntidad = createAsyncThunk('appLogDatos/getTipoEntidad', async () => {
  const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/TipoEntidad`)
  return response.data
})

export const getTraspaso = createAsyncThunk('appLogDatos/getTraspaso', async id => {
  const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/Traspasos/${id}`)
  return response.data.data
})

export const getLog = createAsyncThunk('appLogDatos/getLog', async id => {
  const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/Log/${id}`)
  return response.data.data
})

export const getTotales = createAsyncThunk('appLogDatos/getTotales', async () => {
  const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/Log/getIndicadorTotales`)
  return response.data.data
})

export const downloadExcel = createAsyncThunk('appLogDatos/downloadExcel', async param => {
  const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/Log/excel`, {params: param})
  return response
})

export const getPerfiles = createAsyncThunk('appLogDatos/getPerfiles', async () => {
  const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/UsuariosPerfiles`)
  return response.data
})

export const appLogDatosSlice = createSlice({
  name: 'appLogDatos',
  initialState: {
    data: [],
    total: '',
    params: {},
    allData: [],
    selectedLog: null
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getData.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.param
        state.total = action.payload.totalPages
      })
      .addCase(getLog.fulfilled, (state, action) => {
        state.selectedLog = action.payload
      })
    }
})
export default appLogDatosSlice.reducer
